import { gql } from '@apollo/client';

export const LIST_TRAININGS = gql`
  query ListTrainings($page: Int, $limit: Int, $filters: TrainingFilterInput) {
    listTrainings(page: $page, limit: $limit, filters: $filters) {
      trainings {
        id
        name
        categoryId
        levelId
        thumbnailURL
        createdAt
        updatedAt
      }
      total
      page
      limit
      totalPages
    }
  }
`;

export const CREATE_TRAINING = gql`
  mutation CreateTraining($input: CreateTrainingInput!) {
    createTraining(input: $input) {
      id
      name
      categoryId
      levelId
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_TRAINING = gql`
  mutation UpdateTraining($input: UpdateTrainingInput!, $updateTrainingId: ID!) {
    updateTraining(input: $input, id: $updateTrainingId) {
      id
      name
      categoryId
      levelId
      thumbnailURL
      createdAt
      updatedAt
    }
  }
`;
